export const dashboardOnInit = (filter) => {
    return axios.get('/chain/api/dashboard', {params: filter}).then(res => res.data);
}
export const loadCharts = (filter) => {
    return axios.get('/chain/api/dashboard/charts', {params: filter}).then(res => res.data);
}
export const loadCategories = (filter) => {
    return axios.get('/chain/api/categories', {params: filter}).then(res => res.data);
}
export const changePosition = (items) => {
    return axios.post(`/chain/api/categories/position`, { items }).then(res => res.data);
}
export const changeItemPosition = (items) => {
    return axios.post(`/chain/api/categories/dish_position`, {
        items
    }).then(res => res.data);
}
export const addNewCategory = ({ name, menu_id }) => {
    return axios
        .post(`/chain/api/categories`, {
            name,
            menu_id,
        })
        .then((res) => res.data);
};
export const editNewCategory = (category, archived) => {
    return axios.post(`/chain/api/categories/${category.id}`, {
        category,
        archived
    }).then(res => res.data);
}


